import { JSX } from "react";

export const renderIcon = (icon: JSX.Element) => {
  return icon;
};
